import { render, staticRenderFns } from "./popupReplyList.vue?vue&type=template&id=c810074c&scoped=true&"
import script from "./popupReplyList.vue?vue&type=script&lang=js&"
export * from "./popupReplyList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popupReply.css?vue&type=style&index=0&id=c810074c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c810074c",
  null
  
)

export default component.exports